import _ from "i18n";
import React from "react";

export const APP_ENV = process.env.REACT_APP_APP_ENV;
export const TTP_API_URL = process.env.REACT_APP_TTP_API_URL;
export const TTP_EMAILING_URL = process.env.REACT_APP_TTP_EMAILING_URL;
export const TTP_HOME_URL = process.env.REACT_APP_TTP_HOME_URL;
export const TTP_POWER_TEAM_URL = process.env.REACT_APP_TTP_POWER_TEAM_URL;
export const TTP_PORTAL_URL = process.env.REACT_APP_TTP_PORTAL_URL;
export const TTP_DASHBOARD_URL = process.env.REACT_APP_TTP_DASHBOARD_URL;
export const TTP_UA_URL = process.env.REACT_APP_TTP_UA_URL;

export const TTP_LOGO_URL = "/img/logo.svg";

export const AUTH_COOKIE_NAME = `ttp_auth${
  APP_ENV !== "" ? "_" : ""
}${APP_ENV}`;
console.log("APP_ENV=", APP_ENV);
console.log("TTP_API_URL=", TTP_API_URL);
console.log("TTP_POWER_TEAM_URL=", TTP_POWER_TEAM_URL);
console.log("TTP_UA_URL=", TTP_UA_URL);
export const COMMUNITY_NAME_MAX_LENGTH = 20;
export const COMMUNITY_DEFAULT_LOGO_URL = "/img/default-logo.png";

export const MENUS = {
  GUEST: ["CLIENTS"],
  // READER: ["COMMUNITIES", "CLIENTS"],
  SUPERADMIN: ["COMMUNITIES", "CLIENTS"],
  ADMIN: ["COMMUNITIES", "CLIENTS"],
  // EDITOR: ["COMMUNITIES", "CLIENTS"],
  MANAGER: ["CLIENTS"],
  COLLABORATOR: ["CLIENTS"],
  SUPERVISOR: ["CLIENTS"]
};

export const VERTICAL = "VERTICAL";
export const HORIZONTAL = "HORIZONTAL";

export const APPLICATION = {
  name: "Power Team",
  logo: "powerteam.png"
};

export const PAGES = {
  HOME_PAGE: "HOME_PAGE",
  COMMUNITIES_PAGE: "COMMUNITIES_PAGE",
  SETTING_PAGE: "SETTING_PAGE",
  TIME_SHEET_PAGE: "TIME_SHEET_PAGE",
  FINANCIAL_SHEET_PAGE: "FINANCIAL_SHEET_PAGE"
};

export const PERIODS_UNITS = [
  { value: "MONTHLY", label: _("monthly") },
  { value: "CURRENT", label: _("current") },
  { value: "ANNUAL", label: _("annual") }
];

// export const HIDDEN_MENU_PAGES = [""];

export const SOCIAL_NETWORKS_HOSTS = {
  FACEBOOK: "https://www.facebook.com",
  TWITTER: "https://www.twitter.com",
  LINKEDIN: "https://www.linkedin.com"
};

export const SVG_ICONS = {
  //MainMenu
  PROFILE: "profile.svg",
  PORTAL: "portal.svg",
  NOTIFS: "notifs.svg",
  APPS: "apps.svg",
  EBOX: "ebox.svg"
};

export const ORGANIZATION_STATUS = {
  INITIAL: "INITIAL",
  ACTIVATED: "ACTIVATED",
  NOT_ACTIVATED: "NOT_ACTIVATED",
  PENDING: "PENDING"
};

export const LIST_PAGE_SIZES = [5, 10, 25, 50, 100];

export const SORT_OPTIONS = [
  { label: "oldest first", value: "asc" },
  { label: "newest first", value: "desc" }
];

export const PERIOD_UNIT = {
  DATE: "date",
  MONTH: "month",
  QUARTER: "quarter",
  SEMESTER: "semester",
  YEAR: "year"
};

export const PERIOD_TYPES = ["QUARTERLY", "MONTHLY"];

export const ERP_MODELS = {
  ADMIN_IS_MODEL: {
    label: _("ADMIN_IS"),
    value: "admin_is"
  }
};

export const DAYS_CONFIG = [
  { label: "today", value: "today", daysToSub: 0 },
  { label: "yesterday", value: "yesterday", daysToSub: 1 },
  { label: "otherday", value: "otherday", daysToSub: 2 },
  { label: "week", value: "week", daysToSub: null }
];

export const CYCLE_ITEMS = [
  // "CLIENT_GROUP",
  "CLIENT",
  "TASK_TYPE",
  "COLLABORATOR"
];

export const TREE_TYPES = {
  CLIENT_GROUP: "CLIENT_GROUP",
  CLIENT: "CLIENT",
  TASK_TYPE: "TASK_TYPE",
  COLLABORATOR: "COLLABORATOR",
  CLIENT_MANAGER: "CLIENT_MANAGER",
  ENCODING_DELEGATE: "ENCODING_DELEGATE",
  RESPONSIBLE: "RESPONSIBLE",
  DELEGATED: "DELEGATED"
};

export const TREE_TABS = {
  ALL_FOLDERS: "ALL_FOLDERS",
  MY_FOLDERS: "MY_FOLDERS",
  OTHER_FOLDERS: "OTHER_FOLDERS"
};

export const DIALOG_TYPES = {
  PRIMARY: "primary",
  SUCCESS: "success",
  WARNING: "warning",
  ALERT: "alert"
};

export const STATUS = {
  ALERT: "ALERT",
  WARNING: "WARNING",
  ACCEPTED: "ACCEPTED",
  GREAT: "GREAT"
};

export const STATES = {
  IN_PROGRESS: "IN_PROGRESS",
  LOCKED: "LOCKED",
  UNLOCKED: "UNLOCKED",
  VALID: "VALID",
  NOT_VALID: "NOT_VALID"
};

export const SIGN = {
  POSITIVE: "POSITIVE",
  NEGATIVE: "NEGATIVE"
};

export const MONTHS = [
  "JAN",
  "FEV",
  "MAR",
  "AVR",
  "MAI",
  "JUN",
  "JUL",
  "AOU",
  "SEP",
  "OCT",
  "NOV",
  "DEC"
];

export const COLLABORATOR_STATES = [
  { value: "ACTIVE", label: _("Active"), color: "#62DEB0" },
  { value: "NOT_CONFIGURED", label: _("Not configured"), color: "#FFB06A" },
  { value: "NOT_ACTIVE", label: _("Not active (left)"), color: "#e8eaed" }
];

export const USER_ROLE_TYPES = [
  "LEGAL_REPRESENTATIVE",
  "MANAGER",
  "COLLABORATOR",
  "EXTERNAL"
];
export const USER_ROLE_TYPE_STATUS = ["ADMIN", "MANAGER"];

export const ROLE_TYPES = {
  // key: 'ALL', value: 'All',
  "Accounting roles": [
    { key: "1SUPERADMIN", value: "superadmin" },
    { key: "1ADMIN", value: "admin" },
    { key: "1MANAGER", value: "manager" },
    { key: "1COLLABORATOR", value: "collaborator" }
  ],
  "Organization roles": [
    { key: "2LEGAL_REPRESENTATIVE", value: "LEGAL_REPRESENTATIVE" },
    { key: "2MANAGER", value: "MANAGER" },
    { key: "2OFFICIAL", value: "OFFICIAL" },
    { key: "2EXTERNAL", value: "EXTERNAL" }
  ]
};

export const BUDGET_STATES = [
  { value: "BUDGETED", label: _("budgeted"), color: "#62DEB0" },
  { value: "NON_BUDGETED", label: _("nonBudgeted"), color: "#FFB06A" }
];

export const IS_ENTITY_STATES = [
  { value: "1", label: _("entiteType"), color: "#62DEB0" },
  { value: "0", label: _("attache"), color: "#FFB06A" }
];

export const IS_ENTITY_ALL = [
  { value: "1", label: _("entiteType") },
  { value: "0", label: _("all") }
];

export const STATUS_BUDGET_ECO = [
  { value: "1", label: _("budgeted"), color: "#62DEB0" },
  { value: "0", label: _("nonBudgeted"), color: "#FFB06A" }
];

export const SORT_TYPES = {
  "Trier par collaborateurs": [
    {
      value: "PROFITABLITY_DESC",
      label: _("Meilleure rentabilité")
    },
    {
      value: "PROFITABLITY_ASC",
      label: _("Pire rentabilité")
    },
    {
      value: "VOLUMES_DESC",
      label: _("Plus gros volumes (temps)")
    },
    {
      value: "VOLUMES_ASC",
      label: _("Plus petits volumes (temps)")
    }
  ],
  "Trier par clients": [
    {
      value: "REVENUE_DESC",
      label: _("Clients les plus gros (Chiffre d'affaire)")
    },
    {
      value: "REVENUE_ASC",
      label: _("Clients les plus petits (Chiffre d'affaire)")
    },
    {
      value: "PROFITABLE_CLIENTS_DESC",
      label: _("Clients les plus rentables")
    },
    {
      value: "PROFITABLE_CLIENTS_ASC",
      label: _("Clients les moins rentables")
    },
    {
      value: "VOLUMES_CLIENTS_DESC",
      label: _("Clients les plus gros (temps)")
    },
    {
      value: "VOLUMES_CLIENTS_ASC",
      label: _("Clients les plus petits (temps)")
    }
  ]
};

export const DYNAMIC_TABLE_SORT_TYPES = {
  "Trier par clients": [
    {
      value: "REVENUE_DESC",
      label: _("Clients les plus gros (Chiffre d'affaire)")
    },
    {
      value: "REVENUE_ASC",
      label: _("Clients les plus petits (Chiffre d'affaire)")
    },
    {
      value: "VOLUMES_CLIENTS_DESC",
      label: _("Clients les plus gros (temps)")
    },
    {
      value: "VOLUMES_CLIENTS_ASC",
      label: _("Clients les plus petits (temps)")
    },
    {
      value: "PROFITABLE_CLIENTS_DESC",
      label: _("Clients les plus rentables")
    },
    {
      value: "PROFITABLE_CLIENTS_ASC",
      label: _("Clients les moins rentables")
    }
  ]
};

export const FINANCIAL_COLLABORATOR_SORT_TYPES = {
  "Trier par clients": [
    {
      value: "VOLUMES_CLIENTS_DESC",
      label: _("Clients les plus gros (temps)")
    },
    {
      value: "VOLUMES_CLIENTS_ASC",
      label: _("Clients les plus petits (temps)")
    },
    {
      value: "PROFITABLE_CLIENTS_DESC",
      label: _("Clients les plus rentables")
    },
    {
      value: "PROFITABLE_CLIENTS_ASC",
      label: _("Clients les moins rentables")
    }
  ]
};

export const BUDGET_STATE_CONFIG = [
  {
    id: "all",
    label: _("all"),
    color: "#3c4e64"
  },
  {
    id: "unbudgeted",
    label: _("unbudgeted"),
    color: "#FE3745"
  },
  {
    id: "inProgress",
    label: _("inProgress"),
    color: "#18A0FB"
  },
  {
    id: "budgeted",
    label: _("budgetedState"),
    color: "#06D9B1"
  }
];

export const COOKIES_DATA = [
  AUTH_COOKIE_NAME,
  "XSRF-TOKEN",
  `ttp_session_${APP_ENV}`,
  `ttp_community_${APP_ENV}`
];

export const BUDGET_STATUS = {
  STATUS_GLOBAL_BUDGET_AFFECTED: "GLOBAL_BUDGET_AFFECTED",
  STATUS_UNAUTHORIZED_BUDGET: "UNAUTHORIZED_BUDGET",
  STATUS_GLOBAL_BUDGET_NOT_AFFECTED: "GLOBAL_BUDGET_NOT_AFFECTED",
  STATUS_GLOBAL_BUDGET_AFFECTED: "GLOBAL_BUDGET_AFFECTED",

  STATUS_BUDGET_BY_ZONE_AFFECTED: "BUDGET_BY_ZONE_AFFECTED",
  STATUS_BUDGET_ZONE_DELEGATION_AFFECTED: "BUDGET_ZONE_DELEGATION_AFFECTED",
  STATUS_INFORMATIONS_CLIENT_COMPLETED: "INFORMATIONS_CLIENT_COMPLETED",
  STATUS_MANAGEMENT_TASKES_COMPLETED: "MANAGEMENT_TASKES_COMPLETED",
  STATUS_BUDGET_GLOBAL_COMPLETED: "BUDGET_GLOBAL_COMPLETED",
  STATUS_BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED:
    "BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED",

  STATUS_DELEGATION_NOT_AFFECTED: "DELEGATION_NOT_AFFECTED",

  STATUS_BUDGET_COMPLETED: "BUDGET_COMPLETED"
};

export const BUDGET_STATUS_FILTER = [
  {
    value: "GLOBAL_BUDGET_NOT_AFFECTED",
    label: _("globalBudgetNotAffected"),
    color: "#FF5656"
  },
  {
    value: "GLOBAL_BUDGET_AFFECTED",
    label: _("globalBudgetAffected"),
    color: "#EE8318"
  },
  {
    value: "BUDGET_BY_ZONE_AFFECTED",
    label: _("budgetByZoneAffected"),
    color: "#F49C4E"
  },
  {
    value: "BUDGET_ZONE_DELEGATION_AFFECTED",
    label: _("budgetZoneDelegationAffected"),
    color: "#C7E8FE"
  },
  {
    value: "DELEGATION_NOT_AFFECTED",
    label: _("delegationNotAffected"),
    color: "#BDEDAF"
  },
  // {
  //   value: "BUDGET_ZONE_BY_CATEGORY_NOT_COMPLETED",
  //   label: _("budgetZoneByCategoryNotCompleted"),
  //   color: "#06D9B1"
  // },
  {
    value: "BUDGET_COMPLETED",
    label: _("budgetCompleted"),
    color: "#02AF8E"
  }
];

export const YEARS_VALUES = [2019, 2020, 2021, 2022, 2023, 2024, 2025];

export const CLIENT_TYPE_FILTER = [
  {
    value: "Client Gérant",
    label: _("Client Gérant")
  },
  {
    value: "Client partenaire",
    label: _("Client partenaire")
  },
  {
    value: "Partenaire",
    label: _("Partenaire")
  },
  {
    value: "Client test",
    label: _("Client test")
  },
  {
    value: "IPP particulier 1x/an",
    label: _("IPP particulier 1x/an")
  },
  {
    value: "Contact",
    label: _("Contact")
  },
  {
    value: "New",
    label: _("New")
  },
  {
    value: "New OP",
    label: _("New OP")
  },
  {
    value: "Potentiel",
    label: _("Potentiel")
  },
  {
    value: "Prospect",
    label: _("Prospect")
  },
  {
    value: "Société liée",
    label: _("Société liée")
  },
  {
    value: "Supprimé ds Admin-IS",
    label: _("Supprimé ds Admin-IS")
  }
];

export const CLIENT_GROUP_CRM_FILTER = [
  {
    value: "AiSBL",
    label: _("AiSBL")
  },
  {
    value: "ASBL",
    label: _("ASBL")
  },
  {
    value: "ASBL - Consultation",
    label: _("ASBL - Consultation")
  },
  {
    value: "ASBL - Partenaire",
    label: _("ASBL - Partenaire")
  },
  {
    value: "ASBL petite entreprise",
    label: _("ASBL petite entreprise")
  },
  {
    value: "Contact",
    label: _("Contact")
  },
  {
    value: "Fondation privée",
    label: _("Fondation privée")
  },
  {
    value: "Gérant petite entreprise",
    label: _("Gérant petite entreprise")
  },
  {
    value: "Gérants",
    label: _("Gérants")
  },
  {
    value: "Indépendants",
    label: _("Indépendants")
  },
  {
    value: "Indépendants - Consultation",
    label: _("Indépendants - Consultation")
  },
  {
    value: "Indépendants petite entreprise",
    label: _("Indépendants petite entreprise")
  },
  {
    value: "Partenaire",
    label: _("Partenaire")
  },
  {
    value: "Particuliers",
    label: _("Particuliers")
  },
  {
    value: "Particuliers - Consultation",
    label: _("Particuliers - Consultation")
  },
  {
    value: "Sociétés",
    label: _("Sociétés")
  },
  {
    value: "Sociétés - Partenaire",
    label: _("Sociétés - Partenaire")
  },
  {
    value: "Sociétés petite entreprise",
    label: _("Sociétés petite entreprise")
  },
  {
    value: "Test",
    label: _("Test")
  }
];

export const CLIENT_CRM_TYPE_FILTER = [
  {
    value: "PROSPECT",
    label: _("Prospect")
  },
  {
    value: "CLIENT",
    label: _("client")
  }
];

export const CLIENT_FACTURABLE_STATUS_FILTER = [
  {
    value: "NON_FACTURABLE",
    label: _("Éliminer non facturable")
  },
  {
    value: "NON_FACTURABLE_MAROC",
    label: _("Éliminer non facturable maroc")
  },
  {
    value: "NON_FACTURABLE_BELGIQUE",
    label: _("Éliminer non facturable belgique")
  }
];

export const BUDGET_WARNING_FILTER = [
  {
    value: "UNBALANCED_BUDGET",
    label: _("UNBALANCED_BUDGET"),
    color: "#EE8318"
  },
  {
    value: "SUPERVISOR_ZERO_WARNING",
    label: _("SUPERVISOR_ZERO_WARNING"),
    color: "#EE8318"
  },
  {
    value: "SUPERVISOR_NULL_WARNING",
    label: _("SUPERVISOR_NULL_WARNING"),
    color: "#EE8318"
  },
  {
    value: "GD_ZERO_WARNING",
    label: _("GD_ZERO_WARNING"),
    color: "#EE8318"
  },
  {
    value: "GD_NULL_WARNING",
    label: _("GD_NULL_WARNING"),
    color: "#EE8318"
  },
  {
    value: "GE_ZERO_WARNING",
    label: _("GE_ZERO_WARNING"),
    color: "#EE8318"
  },
  {
    value: "GE_NULL_WARNING",
    label: _("GE_NULL_WARNING"),
    color: "#EE8318"
  },
  {
    value: "SCAN_OP_ZERO_WARNING",
    label: _("SCAN_OP_ZERO_WARNING"),
    color: "#EE8318"
  },
  {
    value: "SE_NULL_WARNING",
    label: _("SE_NULL_WARNING"),
    color: "#EE8318"
  },
  {
    value: "SE_ZERO_WARNING",
    label: _("SE_ZERO_WARNING"),
    color: "#EE8318"
  },
  {
    value: "SCAN_OP_NULL_WARNING",
    label: _("SCAN_OP_NULL_WARNING"),
    color: "#EE8318"
  },
  {
    value: "DELEGATION_ZERO_WARNING",
    label: _("DELEGATION_ZERO_WARNING"),
    color: "#EE8318"
  },
  {
    value: "DELEGATION_NULL_WARNING",
    label: _("DELEGATION_NULL_WARNING"),
    color: "#EE8318"
  }
  // {
  //   value: "DELEGATION_ZONE_WARNING",
  //   label: _("DELEGATION_ZONE_WARNING"),
  //   color: "#EE8318"
  // }
];

export const COLLABORATOR_ROLE_FILTER = [
  {
    value: "null",
    label: _("allFiles")
  },
  {
    value: "MY_FOLDERS",
    label: _("myFolders")
  },
  {
    value: "OTHER_FOLDERS",
    label: _("otherFolders")
  },
  {
    value: "SUPERVISOR",
    label: _("supervisorFolders")
    // },
    // {
    //   value: "ORPHAN",
    //   label: _("orphanFolders")
  }
];

export const COLLABORATOR_ATTRIBUTION_FILTER = [
  {
    value: "ALL_FOLDERS",
    label: _("allFiles")
  },
  {
    value: "BUDGETED_FOLDERS",
    label: _("budgetedFolders")
  },
  {
    value: "HANDLED_FOLDERS",
    label: _("handledFolders")
  }
];

export const MARKS_COLLABORATOR_FILTER = [
  {
    value: 40,
    type: "ALL",
    color: "#3c4e64",
    label: <div>{_("All")}</div>
  },
  {
    value: 0,
    type: "UNTREATED",
    color: "#8d8d8d",
    label: <div>{_("Untreated")}</div>
  },
  {
    value: 20,
    type: "LITTLE_TREATED",

    color: "#2495E1",
    label: <div>{_("inProgress")}</div>
  },
  {
    value: 70,
    type: "NORMAL",
    color: "#FA9437",
    label: <div>{_("advanced")}</div>
  },
  {
    value: 100,
    type: "OVERTAKING",
    color: "red",
    label: <strong>{_("Overtaking")}</strong>
  }
];

export const STATUS_VACATION = {
  PENDING: "PENDING",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED"
};

export const VACATION_STATUS_CONFIG = [
  {
    id: "ALL",
    label: _("all"),
    color: "#3c4e64",
    count: 0
  },
  {
    id: "REJECTED",
    label: _("REJECTED"),
    color: "#FE3745",
    count: 0
  },
  {
    id: "PENDING",
    label: _("PENDING"),
    color: "#FAAD14",
    count: 0
  },
  {
    id: "APPROVED",
    label: _("APPROVED"),
    color: "#06D9B1",
    count: 0
  }
];

export const COLLABORATOR_ROLES = {
  ALL: _("all"),
  SUPERVISOR: "SUPERVISOR",
  GD: "GD",
  GE: "GE",
  SCAN_OP: "SCAN_OP",
  SE: "SE",
  DELEGATED: "DELEGATED"
};

export const COLLABORATOR_ORDER_BUDGET_FILTER = [
  {
    value: "REVENUE_DESC",
    label: _("Clients les plus gros (Bud économique)")
  },
  {
    value: "REVENUE_ASC",
    label: _("Clients les plus petits (Bud économique)")
  },
  {
    value: "VOLUMES_CLIENTS_DESC",
    label: _("Clients les plus gros (Budget horaire)")
  },
  {
    value: "VOLUMES_CLIENTS_ASC",
    label: _("Clients les plus petits (Budget horaire)")
  }
];

export const NEW_COLLABORATOR_ROLE_FILTER = [
  {
    value: "",
    label: _(COLLABORATOR_ROLES.ALL)
  },
  {
    value: COLLABORATOR_ROLES.SUPERVISOR,
    label: _(COLLABORATOR_ROLES.SUPERVISOR)
  },
  {
    value: COLLABORATOR_ROLES.GD,
    label: _(COLLABORATOR_ROLES.GD)
  },
  {
    value: COLLABORATOR_ROLES.GE,
    label: _(COLLABORATOR_ROLES.GE)
  },
  {
    value: COLLABORATOR_ROLES.SCAN_OP,
    label: _(COLLABORATOR_ROLES.SCAN_OP)
  },
  {
    value: COLLABORATOR_ROLES.SE,
    label: COLLABORATOR_ROLES.SE
  },
  {
    value: COLLABORATOR_ROLES.DELEGATED,
    label: COLLABORATOR_ROLES.DELEGATED
  }
];

export const COLLABORATOR_ROLE_ATTRIBUT = [
  {
    value: "",
    label: _(COLLABORATOR_ROLES.ALL)
  },
  {
    value: "supervisor",
    label: _(COLLABORATOR_ROLES.SUPERVISOR)
  },
  {
    value: "manager",
    label: _(COLLABORATOR_ROLES.GD)
  },
  {
    value: "encodingManager",
    label: _(COLLABORATOR_ROLES.GE)
  },
  {
    value: "scanOperator",
    label: _(COLLABORATOR_ROLES.SCAN_OP)
  },
  {
    value: "encodingSupervisor",
    label: COLLABORATOR_ROLES.SE
  }
];

export const VAT_PERIODICITY = [
  {
    value: "0",
    label: _("Trimestre")
  },
  {
    value: "1",
    label: _("Mensuel")
  },
  {
    value: "2",
    label: _("'Non soumis")
  },
  {
    value: "4",
    label: _("Annuellement - Régime d'exonération des petites entreprises")
  },
  {
    value: "11",
    label: _("Mixte/Partiel")
  },
  {
    value: "12",
    label: _("Unité TVA")
  },
  {
    value: "13",
    label: _("Exempté art 44")
  },
  {
    value: "14",
    label: _("Particulier")
  },
  {
    value: "15",
    label: _("TVA spéciale")
  }
];

export const CLOSING_DATE_FOLDER_FILTER = [
  {
    value: "",
    label: _("Tous")
  },
  {
    value: "12-31",
    label: _("31/12")
  },
  {
    value: "11-30",
    label: _("30/11")
  },
  {
    value: "09-30",
    label: _("30/09")
  },
  {
    value: "07-31",
    label: _("31/07")
  },
  {
    value: "06-30",
    label: _("30/06")
  },
  {
    value: "03-31",
    label: _("31/03")
  },
  {
    value: "02-28",
    label: _("28/02")
  }
];

export const DELETED_STATUS = [
  {
    value: "DELETED",
    label: _("deleted")
  },
  {
    value: "NOT_DELETED",
    label: _("persistent")
  }
];

export const OFFSHORE_STATUS = [
  {
    value: "OFFSHORE",
    label: _("Offshore")
  },
  {
    value: "NOT_OFFSHORE",
    label: _("Non Offshore")
  }
];

export const URL_HASH_KEY = "Y3YZVA6uSLVqJhAWHdsb9CsGgcBXIhmY";



// WEBPACK FOOTER //
// ./src/config/index.js